import Phaser from 'phaser';

export class ParticleFxSystem {
  constructor(private readonly scene: Phaser.Scene) {}

  burst(x: number, y: number, color: number, count = 12) {
    for (let index = 0; index < count; index += 1) {
      const particle = this.scene.add.circle(x, y, Phaser.Math.Between(4, 9), color, 0.9);
      const angle = Phaser.Math.FloatBetween(0, Math.PI * 2);
      const distance = Phaser.Math.Between(48, 160);

      this.scene.tweens.add({
        targets: particle,
        x: x + Math.cos(angle) * distance,
        y: y + Math.sin(angle) * distance,
        alpha: 0,
        scaleX: 0.1,
        scaleY: 0.1,
        duration: Phaser.Math.Between(280, 520),
        ease: 'Cubic.easeOut',
        onComplete: () => particle.destroy(),
      });
    }
  }
}
